export const MAX_REPORTS_PER_PAGE = 50;

export const DATE_TO_SEND = 'date_to_send';
export const CREATED_AT = 'created_at';
export const ORDER_ID = 'order_id';
export const UID = 'uid';
export const ENGAGEMENT_SOURCE_TYPE = 'engagement_source_type';

export const AWAITING_SHIPMENT = 'awaiting_shipment';
export const AWAITING_ADDRESS = 'awaiting_address';
export const VIEWED = 'viewed';
export const CANCELED = 'canceled';
export const COMPLETED = 'completed';
export const NEW = 'New';
export const SHIPPED = 'shipped';
export const IN_FULFILLMENT = 'in_fulfillment';
export const DELIVERED = 'delivered';
export const EXPIRED = 'expired';
export const FAILED = 'failed';

export const PAYMENT_PENDING = 'Payment Pending';
export const PROCESSING_ORDER = 'Processing Order';
export const GIFT_CLAIMED = 'Gift Claimed';
export const EMAIL_SENT = 'Email Sent';
export const EMAIL_DELIVERED = 'Email Delivered';
export const EMAIL_REJECTED = 'Email Rejected;';
export const EMAIL_BOUNCED = 'Email Bounced';
export const EMAIL_QUEUED = 'Email Queued';
export const EMAIL_OPENED = 'Email Opened';
export const EMAIL_BLOCKED = 'Email Blocked';
export const PROCESSING = 'processing';

export const SINGLE = 'Single';
export const DIRECT = 'Direct';
export const BULK = 'Bulk';
export const ONE_LINK = 'One link';
export const ZAPIER = 'Zapier';
export const WEBHOOK = 'Webhook';
export const NEW_HIRE_CAMPAIGN = 'New hire campaign';
export const BIRTHDAY_CAMPAIGN = 'Birthday campaign';
export const ANNIVERSARY_CAMPAIGN = 'Anniversary campaign';
export const HUBSPOT = 'HubSpot';
